<template>
  <ul :class="[$style.filters, { [$style['filters-head']]: insideHeader }]">
    <li
      :class="{ [$style.current]: current === 'all' }"
      @click="() => action('all')"
    >
      Toutes
    </li>
    <li
      v-for="item in items"
      :key="item.slug"
      :class="{ [$style.current]: current === item.slug }"
      @click="handleClickItem(item)"
    >
      {{ capitalize(item.name) }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { Category } from '~/types'

const props = withDefaults(
  defineProps<{
    items: Category[]
    current: string
    action: (slug: string) => void
    insideHeader?: boolean
  }>(),
  {
    insideHeader: false,
  },
)

const handleClickItem = (item: Category) => {
  if (item.slug) {
    props.action(item.slug)
  }
}
</script>

<style lang="scss" module>
.filters {
  display: flex;
  align-items: flex-end;
  width: 100%;
  padding-right: 2.5rem;
  overflow-x: auto;
  list-style-type: none;
  scroll-snap-type: x proximity;

  @media (min-width: 700px) {
    flex-wrap: wrap;
    width: calc(100% + 2.5rem);
    margin: 0 -1.2rem;
    padding: 0;
  }

  li {
    flex-shrink: 0;
    margin-bottom: 2rem;
    padding-left: 2.5rem;
    font-size: 1.2rem;
    font-weight: 500;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    cursor: pointer;
    transition: color 0.35s ease-in-out;
    user-select: none;
    scroll-snap-align: start;

    @media (min-width: 700px) {
      padding: 0 1.2rem;
    }

    &.current {
      color: $blue;
    }
  }

  // Override for header placement
  &-head {
    width: calc(100% + 5rem);
    margin: 0 -2.5rem;

    @media (min-width: 700px) {
      width: 100%;
      margin: 0 -1.2rem;
    }

    li {
      margin: 0;
      padding: 1rem 0 1rem 2.5rem;

      @media (min-width: 700px) {
        padding: 1rem 1.2rem;
      }
    }
  }
}
</style>
